import React, { useEffect, useRef, useState } from "react";
import { Button } from "primereact/button";
import { IoAddOutline } from "react-icons/io5";
import { InputText } from "primereact/inputtext";
import { Toast } from "primereact/toast";
import { FileUpload } from "primereact/fileupload";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import GlobalPopup from "../GlobalComponents/GlobalPopup";
import { ProgressSpinner } from "primereact/progressspinner";
import { Checkbox } from "primereact/checkbox";
import HapPlants from "../Images/HapPlants .jpg";
import {
  axiosapibaseurl,
  axiosDTVbasicAuthForm,
  postAPICall,
  putAPICall,
  setToastRef,
  showErrorToast,
  showSuccessToast,
} from "../Api/Api";
import "../AdminScreenDetail/AdminStyle.css";
import axios from "axios";

export default function TVAPPConfig(props) {
  const [searchQuery, setSearchQuery] = useState("");
  const [showDialog, setShowDialog] = useState(false);
  const [required, setRequired] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [editedItems, setEditedItems] = useState(null);
  const [tvAppDetail, setTvAppDetail] = useState([]);
  const [version, setVersion] = useState("");
  const [loading, setLoading] = useState(false);
  const fileUploadRef = useRef(null); // Reference to FileUpload component
  const [checked, setChecked] = useState(false);
  const [errors, setErrors] = useState({
    from: "",
    password: "",
    days: "", // Error for days input
  });
  const toast = useRef(null);

  useEffect(() => {
    setToastRef(toast.current);
    GetTVAppDetails();
  }, []);

  const GetTVAppDetails = async () => {
    debugger;
    const response = await postAPICall("api/TVAppDetails/GetTvAppDetails");
    if (response) {
      setTvAppDetail(response?.data?.Data);
    }
  };

  const validateVersion = (version) => {
    return version.trim() !== ""; // Returns false if version is empty or contains only spaces
  };

  const handleFileSelect = (event) => {
    if (event.files.length > 0) {
      setSelectedFile(event.files[0]); // Store selected file
    }
  };

  const handleSave = async () => {
    debugger;
    const VersionValidation = version ? version : editedItems?.Version;
    if (!VersionValidation || !validateVersion(VersionValidation)) {
      setRequired(true);
    }
    if (selectedFile) {
      let isValid = true; // Flag to check overall validity
      let errors = {}; // Object to store error messages
      // Validate email (either from state or editedItems)

      if (!VersionValidation || !validateVersion(VersionValidation)) {
        errors.from = "Please enter a Version !!";
        isValid = false;
      }

      if (!isValid) {
        setErrors(errors);
        return;
      }
      // Step 1: Check locally in tvAppDetail DataTable
      const isVersionExists = tvAppDetail.some(
        (item) => item.Version === VersionValidation
      );

      if (isVersionExists) {
        showErrorToast("Version already exists in the DataTable!");
        return; // Stop process if version exists
      }

      setLoading(true);
      const formData = new FormData();
      formData.append("Version", version);
      formData.append("PAppUrl", selectedFile);
      formData.append("Status", 1);
      formData.append("ForceUpdate", checked);

      // API call for POST request
      let endpointURL = "api/TVAppDetails/PostUploadApkFile";
      const response = await axios.post(
        `${axiosapibaseurl}${endpointURL}`,
        formData,
        axiosDTVbasicAuthForm
      );
      if (response.status === 200) {
        showSuccessToast(response?.data?.Message);
        setLoading(false);
        GetTVAppDetails();
        if (fileUploadRef.current) {
          fileUploadRef.current.clear(); // Clears the selected file from UI
        }
        setVersion("");
        setErrors("");
        setChecked(false);
        setEditedItems(null);
        setShowDialog(false);
      }
    } else {
      showErrorToast("Please Upload Apk File..!");
    }
  };

  // const handleInputVersion = (e) => {
  //   const { value } = e.target;
  //   setVersion(value); // Update the `from` state
  //   setRequired(false);
  //   setErrors("");
  //   setEditedItems((prevState) => ({
  //     ...prevState,
  //     Version: value, // Update the `EmailAddress` field in `editedItems`
  //   }));
  // };
  const handleInputVersion = (e) => {
    const { value } = e.target;

    // Regular expression to allow numbers and dots (with trailing dots)
    const versionPattern = /^[0-9.]*$/;

    if (value === "" || versionPattern.test(value)) {
      setVersion(value); // Update state
      setRequired(false);
      setErrors(""); // Clear errors if valid
      setEditedItems((prevState) => ({
        ...prevState,
        Version: value, // Update `Version` field in `editedItems`
      }));
    } else {
      setErrors("Invalid format! Only numbers & dots allowed.");
    }
  };

  const handleCheckboxChange = async (e, rowData) => {
    // Allow editing only if the status is 0 (unchecked)
    if (rowData.Status === 0) {
      const RequestBody = {
        AppUrl: rowData.AppUrl,
        ForceUpdate: rowData.ForceUpdate,
        Id: rowData.Id,
        Name: rowData.Name,
        Status: 1,
        Version: rowData.Version,
      };
      const response = await putAPICall(
        "api/TVAppDetails/PutTvAppDetails",
        RequestBody
      );
      if (response?.status == 200) {
        GetTVAppDetails();
        showSuccessToast(response?.data?.Message);
      }
      rowData.Status = e.checked ? 1 : 0; // Toggle status between 1 and 0
      setTvAppDetail([...tvAppDetail]); // Update state with the modified row
    }
  };

  const filteredTVAppDataSource = tvAppDetail?.filter((TvApp) =>
    TvApp.Name.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const handleClosePopup = () => {
    setRequired(false);
    setShowDialog(false);
    setVersion("");
    setErrors("");
    setEditedItems(null);
    setChecked(false);
  };

  const AddNewTVAPPFooter = (
    <div>
      <Button
        id="BtnSave"
        label="Save"
        icon="pi pi-check"
        onClick={handleSave}
        autoFocus
      />
      <Button
        id="BtnCancel"
        label="Cancel"
        icon="pi pi-times"
        onClick={handleClosePopup}
        className="p-button-text"
      />
    </div>
  );

  const AddTVAPPContent = (
    <>
      <div className="upload-container">
        {/* First Row */}
        <div className="TVApprow">
          <div>
            <label htmlFor="UploadApk">UploadApk :</label>
            <FileUpload
              style={{ marginTop: "10px" }}
              ref={fileUploadRef}
              id="UploadApk"
              mode="basic"
              customUpload
              name="demo[]"
              accept="application/vnd.android.package-archive"
              onSelect={handleFileSelect}
              emptyTemplate={
                <p className="m-0">Drag and drop files to here to upload.</p>
              }
            />
          </div>

          <div className="p-field">
            <label htmlFor="Version">Version :</label>
            <br />
            <InputText
              id={required ? "Version" : ""}
              value={editedItems?.Version || ""}
              onChange={handleInputVersion}
              placeholder="Enter your Version"
              className="p-inputtext p-component"
            />
            <br />
            {errors.from && <small className="p-error">{errors.from}</small>}
          </div>
        </div>

        {/* Second Row */}
        <div className="TVApprow">
          <div className="p-field">
            <label htmlFor="ForceUpdate">Force Update :</label>
            <Checkbox
              id="ForceUpdate"
              onChange={(e) => setChecked(e.checked)}
              checked={checked}
            />
          </div>
        </div>
      </div>
    </>
  );

  return (
    <div>
      <Toast ref={toast} />
      {loading && (
        <div className="loading-overlay">
          <ProgressSpinner />
          <img
            src={HapPlants}
            alt="icon"
            className="spinner-icon"
            style={{ width: "30px", height: "30px", borderRadius: "50px" }}
          />
        </div>
      )}
      <div
        id="plus_search"
        style={{ display: "flex", justifyContent: "flex-end" }}
      >
        <Button
          icon={
            <IoAddOutline
              style={{ color: "darkslategrey", fontSize: "50px" }}
            />
          }
          id="MasterPlusicon"
          onClick={() => setShowDialog(true)}
          className="p-button p-button-icon"
          title="Add"
        />
        <InputText
          id="Tv App Search"
          type="search"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          placeholder="Search..."
        />
        <Button
          icon="pi pi-search"
          id="searchicon"
          style={{
            backgroundColor: "lightslategray",
            border: "lightslategray",
          }}
          className="p-button-primary"
          title="Search"
        />
      </div>
      <DataTable
        className="TV_APPDataTable"
        header="TV APP"
        scrollable
        scrollHeight="440px"
        value={filteredTVAppDataSource}
      >
        <Column field="Name" header="Name" />
        <Column field="AppUrl" header="AppUrl" sortable />
        <Column field="Version" header="Version" />
        <Column
          field="Status"
          header="Status"
          body={(rowData) => (
            <Checkbox
              checked={rowData.Status === 1}
              onChange={(e) => handleCheckboxChange(e, rowData)}
              disabled={rowData.Status === 1} // Disable if Status is 1
            />
          )}
        />
      </DataTable>
      <GlobalPopup
        draggable={true}
        title="Add TV App"
        visible={showDialog}
        onHide={handleClosePopup}
        footerButtons={AddNewTVAPPFooter}
        content={AddTVAPPContent}
        Popupheight={300}
        Popupwidth={500}
      />
    </div>
  );
}
